<div class="overlay-inner-wrapper" style="height: 100%;">
  <form clrForm [formGroup]="rueckmeldungForm" [clrLabelSize]="4" class="width100">
    <div class="clr-row nxm">
      <div class="clr-col-sm">
        @if(!auftrag()) {
          <clr-select-container>
            <label>{{ 'Instandsetzer' | mrTranslate }}</label>
            <select clrSelect [(ngModel)]="firmenId" class="w-100-p" [ngModelOptions]="{ standalone: true }">
              <option [ngValue]="null" disabled>{{ 'Firma auswählen' | mrTranslate }}</option>
              @for (firm of firmen(); track firm.ID) {
              <option [ngValue]="+firm.ID">{{ firm.mFirma }}</option>
              }
            </select>
          </clr-select-container>
        }

        <clr-date-container>
          <label>{{ 'Datum' | mrTranslate }}</label>
          <input
            type="date"
            clrDate
            name="datum"
            [ngModel]="rueckmeldungForm.get('datum').value | localeDate"
            (ngModelChange)="rueckmeldungForm.get('datum').setValue(localeDate.tosql($event))"
            [ngModelOptions]="{ updateOn: 'blur', standalone: true }"
            [disabled]="rueckmeldungForm.disabled"
            required />
        </clr-date-container>
        <clr-datalist-container>
          <label class="clr-col-12 clr-col-md-4">{{ 'Verantwortlich' | mrTranslate }}</label>
          <input
            clrDatalistInput
            id="verantwortlichmangel"
            list="verantwortlichlist"
            placeholder=""
            name="Option"
            formControlName="verantwortlich"
            class="clr-col-12 clr-col-md-8" />
          <datalist id="verantwortlichlist">
            @for (c of verantwortlicher; track c) {
              <option [value]="c"></option>
            }
          </datalist>
        </clr-datalist-container>
        <clr-textarea-container>
          <label>{{ 'Rückmeldetext' | mrTranslate }}</label>
          <textarea rows="3" clrTextarea formControlName="rueckmeldetext" name="description"></textarea>
        </clr-textarea-container>
      </div>
      <div class="clr-col-sm-1"></div>
      <div class="clr-col-sm">
        <clr-datalist-container>
          <label class="clr-col-12 clr-col-md-4">{{ 'Kostenart' | mrTranslate }}</label>
          <input
            clrDatalistInput
            id="kostenartmangel"
            list="kostenartlist"
            placeholder=""
            name="Option"
            formControlName="kostenart"
            class="clr-col-12 clr-col-md-8" />
          <datalist id="kostenartmangellist">
            @for (c of kostenartmangel; track c) {
              <option [value]="c"></option>
            }
          </datalist>
        </clr-datalist-container>
        <clr-textarea-container>
          <label>{{ 'Teilerneuerung' | mrTranslate }}</label>
          <textarea rows="2" clrTextarea formControlName="teilerneuerung" name="description" (blur)="leaveTE($event,'teilerneuerung')"></textarea>
        </clr-textarea-container>
        <clr-textarea-container>
          <label>{{ 'Bemerkung' | mrTranslate }}</label>
          <textarea rows="2" clrTextarea formControlName="bemerkung" name="description" (blur)="leaveTE($event,'bemerkung')"></textarea>
        </clr-textarea-container>
      </div>
    </div>

  <div class="w-100-p margin--12-l">
    <app-preview-thumbnails
      [drag_drop]="true"
      [acceptTypes]="'image/*, video/*, .pdf'"
      (openPdfOverlay)="openPdf($event)"
      [getBigFileFnc]="media.getApiFunctionMediaBig"
      (returnFnc)="leaveBild()">
      </app-preview-thumbnails>
  </div>
</form>
  <div class="clr-row nxm nxp">
    <div class="clr-col" style="display: flex; flex-flow: row wrap; justify-content: flex-end">
      <button
        type="button"
        class="btn btn-primary"
        style="flex-shrink: 0"
        [disabled]="disableSendBtn()"
        (click)="sendRueckmeldung()">
        {{ mangelTablrueck?.rows?.length }}
        {{ 'Mängel rückmelden' | mrTranslate }}
      </button>
    </div>
  </div>
  <div class="clr-row nxm padding-10-b" style="height: calc(100% - 480px - 50px)">
    <div class="clr-col h-100">

        <clr-datagrid
          #mnglRueckDg
          [clrDgItemsIdentityFn]="row => row?.omazsid"
          [clrDgSelectionType]="'single'"
          [clrDgSelected]="[selectedMangel()]"
          (clrDgSelectedChange)="setSelectedMangel($event[0])"
          class="datagrid-compact auftragDetailMangelTable h-100"
          id="mangelTablrueck">
          @for (column of mangelTablrueck.columns; track column.id) {
            <clr-dg-column>
              <ng-container
                *clrDgHideableColumn="{
                  hidden: column.id | hideIDColumns: ['kauftmid', 'auftragid', 'bezirk', 'stellwerk', 'bild'],
                }">
                {{ column.id | mrTranslate | titlecase }}
              </ng-container>
            </clr-dg-column>
          }
          <ng-template
            clrVirtualScroll
            let-row
            [clrVirtualRowsOf]="mangelTablrueck.rows"
            [clrVirtualRowsTrackBy]="(_, row) => row?.omazsid">
            <clr-dg-row  [clrDgItem]="row">
              @if (auftrag?.Auftragsstatus == 0) {
                <clr-dg-action-overflow>
                  <button class="action-item" (click)="deleteMangelAuftrag(row)">
                    {{ 'Mangel aus Auftrag löschen' | mrTranslate }}
                  </button>
                </clr-dg-action-overflow>
              }
              @for (cell of mangelTablrueck.columns; track cell.id) {
                <clr-dg-cell class="name-cell">{{ row[cell.id] | tablePrettyPrint }}</clr-dg-cell>
              }
            </clr-dg-row>
          </ng-template>
          <clr-dg-footer>{{ mangelTablrueck.rows.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
        </clr-datagrid>
      
    </div>
  </div>
</div>